import { Admin } from "react-admin";
import { Resource } from '@react-admin/ra-rbac';
import cryptoOrders from "../pages/cryptoOrders";
import cryptoConversions from "../pages/cryptoConversions";
import paymentLinks from "../pages/paymentLinks";
import PaymentRequest from "../pages/paymentLinks/payment-request";
import users from "../pages/users";
import accounts from "../pages/accounts";
import projects from "../pages/projects";
import gasStationTransfers from "../pages/gasStation/transfers";
import gasStationStatements from "../pages/gasStation/statements";
import dashboard from "../dashboards/general";
import authProvider from "./authProvider";
import dataProvider from "./dataProvider";
import CoinhouseSolutionsAdminLayout from "../layout/CoinhouseSolutionsAdminLayout";
import { QueryClient } from "react-query";
import { themeCreator } from "../themes/base";
import CoinhouseSolutionsLoginPage from "../pages/Auth/Login/Basic";
import RecoverPasswordBasic from "../pages/Auth/RecoverPassword/index";
import ResetPasswordToken from "../pages/Auth/RecoverPassword/resetPassword";
import LoginCover from "../pages/Auth/Login/Cover";
import { OrderCreate } from "../pages/cryptoOrders/create";
import { AccountProjectProvider } from "../contexts/AccountProjectContext";
import { CustomRoutes } from "react-admin";
import { Route } from "react-router-dom";
import NotFound from "../components/NotFound";
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
});
const App = () => (
  <Admin
    loginPage={LoginCover}
    dashboard={dashboard}
    layout={CoinhouseSolutionsAdminLayout}
    authProvider={authProvider}
    dataProvider={dataProvider}
    theme={themeCreator("brandTheme")}
    queryClient={queryClient}
    title="Coinhouse Solutions - Admin"
    catchAll={NotFound}
  >
      <Resource
        name="accounts"
        recordRepresentation="name"
        {...accounts}
        options={{ label: "Accounts" }}
      />
      <Resource name="users" {...users} options={{ label: "Users" }} />
      <Resource name="userPassword"  options={{ label: "User Passwords" }} />
      <Resource
        name="cryptoOrders"
        {...cryptoOrders}
        options={{ label: "Crypto Orders" }}
        create={OrderCreate}
        show={cryptoOrders.show}
        recordRepresentation={(record) => `Order ${record.internalRef}`}
      />
      <Resource
        name="cryptoConversions"
        {...cryptoConversions}
        options={{ label: "Crypto Conversions" }}
      />
      <Resource
        name="paymentLinks"
        options={{ label: "Payment Links" }}
        {...paymentLinks}
      />
      <Resource
        name="cryptoOrdersStatistics"
        options={{ label: "Crypto Orders Statistics" }}
      />
      <Resource name="projectsByAccount" options={{ label: "Projects By Account" }} />
      <Resource name="cryptoPayments" options={{ label: "Crypto Payments" }} />
      <Resource
        name="cryptoOrdersPayments"
        options={{ label: "Crypto Orders Payments" }}
      />
      <Resource
        name="cryptoOrdersConversions"
        options={{ label: "Crypto Orders Conversions" }}
      />
      <Resource name="statsByProject" options={{ label: "Stats By Project" }} />
      <Resource name="portfolioByProject" options={{ label: "Portfolio By Project" }} />
      <Resource name="projects" {...projects} options={{ label: "Projects" }} recordRepresentation={(record) => `${record.name}`}/>
      <Resource name="documentOrder" options={{ label: "Document Order" }} />
      <Resource name="cryptoOrdersKyts" options={{ label: "Crypto Orders Kyts" }} />
      <Resource
        name="gasStationTransfers"
        {...gasStationTransfers}
        options={{ label: "Gas Station Transfers" }}
      />
      <Resource
        name="gasStationStatements"
        {...gasStationStatements}
        options={{ label: "Gas Station Statements" }}
      />
      <CustomRoutes noLayout>
            <Route path="/recover-password" element={<RecoverPasswordBasic />} />
            <Route path="/password/reset/:token" element={<ResetPasswordToken />} />
        </CustomRoutes>
        <CustomRoutes noLayout>
            <Route path="/payment-request/:id" element={<PaymentRequest />} />
        </CustomRoutes>
  </Admin>
);

export default App;
